import { Column, Row } from '@cdab/scania/qpr/components/atoms'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  margin-top: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 0;
  }
`
export const Title = styled.h3.attrs({
  className: 'tds-headline-03'
})`
  margin-bottom: 8px;
  margin-top: 8px;
`
export const StyledColumn = styled(Column)`
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 8px;
    margin-bottom: 4px;
  }
`
export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 12px;
  }
`
export const StyledFirstButtonWrapper = styled.div`
  padding-right: 8px;
`
export const StyledButtonWrapper = styled.div`
  flex: 0.13;
  padding-right: 8px;
`
export const StyledSectionTitle = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
`
export const UploadFileButtonWrapper = styled.div`
  padding-right: 4px;
  margin-top: 12px;
`

export const SpinnerWrapper = styled.div`
  flex: 0.13;
  padding-right: 4px;
`
export const StyledMessage = styled.div`
  flex: auto;
`

export const StyledLastButtonWrapper = styled.div`
  flex: 1 0 30%;
  direction: rtl;
`

export const StyledTextfieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 8px;
`

export const StyledLinkRow = styled(Row)`
  display: flex;
  align-items: center;
`
